import { ADMIN_ROUTING } from "./admin-routing";
import { ADMINISTRATION_ROUTING } from "./administration-routing";
import {
  ONBOARDING_ORGANIZATION_PATH,
  REGISTER_JOIN_PATH,
} from "./auth-routing";
import { MAINTENANCE_ROUTING } from "./maintenance-routing";
import { OPERATIONS_ROUTING } from "./operations-routing";
import { ORGANIZATION_ADMIN_ROUTING } from "./organization-admin-routing";
import { PERFORMANCE_ROUTING } from "./performance-routing";
import {
  LEGACY_ADMINISTRATION_REPORTS_ROUTING,
  REPORTS_ROUTING,
} from "./reports-routing";
import { RouteParameters } from "./route-parameters";
import { SUPPORT_VEHICLE_ROUTING } from "./support-vehicle-routing";
import type { NestedRoutePaths } from "./types";

const ROUTING = {
  CHECKOUT_CANCEL: "/checkout/cancel",
  CHECKOUT_SUCCESS: "/checkout/success",
  DASHBOARD: {
    ADMINISTRATION: ADMINISTRATION_ROUTING,
    /** @deprecated Prefer {@link REPORTS_ROUTING}; kept for redirect sources. */
    LEGACY_ADMINISTRATION_REPORTS: LEGACY_ADMINISTRATION_REPORTS_ROUTING,
    ORGANIZATION: ORGANIZATION_ADMIN_ROUTING,
    REPORTS: REPORTS_ROUTING,
    ROOT: "/dashboard",
    SUPPORT_VEHICLES: SUPPORT_VEHICLE_ROUTING,
    [RouteParameters.AIRPLANE_ID]: {
      ADMIN: ADMIN_ROUTING,
      FAQ: `/dashboard/:${RouteParameters.AIRPLANE_ID}/f-a-q`,
      LANDING: `/dashboard/:${RouteParameters.AIRPLANE_ID}/landing`,
      MAINTENANCE: MAINTENANCE_ROUTING,
      OPERATIONS: OPERATIONS_ROUTING,
      ORGANIZATION_DETAILS: `/dashboard/:${RouteParameters.AIRPLANE_ID}/organization-details`,
      PERFORMANCE: PERFORMANCE_ROUTING,
      PROFILE_DETAILS: `/dashboard/:${RouteParameters.AIRPLANE_ID}/profile-details`,
      ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}`,
    },
  },
  FAQ: "/FAQ",
  FORGOT_PASSWORD: "/login/forgot-password",
  HOME: "/home",
  LOGIN: "/login",
  ONBOARDING_ORGANIZATION: ONBOARDING_ORGANIZATION_PATH,
  REGISTER: "/register",
  REGISTER_JOIN: REGISTER_JOIN_PATH,
  RESET_PASSWORD: "/reset-password",
  ROOT: "/",
} as const;

/** Every concrete path literal in {@link ROUTING} (all nesting levels). */
type SUPPORTED_ROUTES = NestedRoutePaths<typeof ROUTING>;

export { ROUTING, type SUPPORTED_ROUTES };
